import fixDateTimezone from '../../utils/fixDateTimezone';
import formatDate from '../../utils/formatDate';

// Колонка «Обновлён» списка лидов: когда по лиду в последний раз подали заявку в банк. Пусто — активности не было.
const leadUpdatedAt = (row) => (row?.lastActivityAt ? formatDate(fixDateTimezone(row.lastActivityAt), true) : '');

export default leadUpdatedAt;
